// extracted by mini-css-extract-plugin
module.exports = {"sponsors":"SponsorSection_sponsors__5_FEf","sponsor":"SponsorSection_sponsor__m2Ni-","logos":"SponsorSection_logos__3ZUzi"};